import React from 'react';
import { ListGroup } from 'react-bootstrap';

const SearchResultCcVideo = ({ result, ...props }) => {
  const { title, description, url, previewImage } = result.attributes

  return (
    <ListGroup.Item action {...props} href={url} className="global-search-result-item" active={false}>
      <div className="global-search-preview-image-container text-dark">
        <img src={previewImage} alt="Support Video" className="img-fluid" />
      </div>
      <div className="global-search-preview-details-container">
        <span className="text-dark fw-medium"> { title } </span>
        { description && <div className="text-muted">{ description }</div> }
      </div>
    </ListGroup.Item>
  )
}

export default SearchResultCcVideo
